import script from "./CreatePostModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatePostModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreatePostModal.vue?vue&type=style&index=0&id=bf4efa76&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf4efa76"]])

export default __exports__